(function (window) {
    window._env = window._env || {};

    // API url
    window._env.apiUrl = 'https://finance-api.stylemix.net/api';
    //window._env.apiUrl = 'http://api.finance.smt.test/api';
    window._env.routeProvider = {
        debug: true
    }
}(this));